
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpclientService } from '../../services/httpclient.service';
import { ExtensiveLoggingDto } from 'src/app/model/extensive-logging-dto';
import { AppSettingService } from 'src/app/services/app-setting.service';

@Component({
  selector: 'app-ext-log',
  templateUrl: './ext-log.component.html',
  styleUrls: ['./ext-log.component.css']
})
export class ExtLogComponent implements OnInit {
  loading;
  modalPopup = false;
  modalPopup1 = false;
  isStatus: boolean;
  extensiveLoggingList: ExtensiveLoggingDto[];
  exportModal: string;
  mlrPaginationcount = 25;
  public mlrPaginationConfiguration;
  SelectAllRowModalUpfr: boolean;
  successMessage;
  isExtLogchanges = false;
  constructor(private httpclientService: HttpclientService, private router: Router, public appSettingService: AppSettingService) { 
    this.exportModal = this.appSettingService.exportList[0];
    this.mlrPaginationConfiguration = { currentPage: '25 per page', itemsPerPage: '25' };

  }

  ngOnInit() {

    this.getExtentiveLogging();
  }
  
  pressingOK() {
    this.modalPopup = false;
  
  }
  pressingCancel() {
    this.modalPopup = false;
  }
  pressingOK1() {
    // this.saving="";
    this.modalPopup1 = false;
  }
  checkValue(values:any){
    // console.log(values.currentTarget.checked);
    // this.isStatus=values.currentTarget.checked;
 }

 clearAllSelection() {
  this.SelectAllRowModalUpfr = false;
  //this.initialSortValue();
 
}



/****************************************************** Row Selection Start ***************************************************/
mlrOnSelectParticularRow(selectedItem: any, values: any) {
  // if (values.currentTarget.checked) {
  //   this.fileExportService.selectedUnprocessedPoReportData.push(selectedItem);
  // } else if (!values.currentTarget.checked) {
  //   this.fileExportService.selectedUnprocessedPoReportData =
  //   this.fileExportService.selectedUnprocessedPoReportData.filter(obj => obj !== selectedItem);
  // }
  // if (this.fileExportService.selectedUnprocessedPoReportData.length === this.unprocessedPoReportDtoList.length) {
  //   this.SelectAllRowModalUpfr = true;
  // } else {
  //   this.SelectAllRowModalUpfr = false;
  // }
}

mlrOnSelectAllRow(values: any) {
// this.selectedUnprocessedPoReportDtoList = [];
// if (values.currentTarget.checked) {
//   this.unprocessedPoReportDtoList.forEach(pdto => {
//     pdto.rowCheck = true;
//     this.selectedUnprocessedPoReportDtoList.push(pdto);
//   });
//   this.unprocessedPoReportDtoList = this.selectedUnprocessedPoReportDtoList;
//   this.fileExportService.selectedUnprocessedPoReportData = this.selectedUnprocessedPoReportDtoList;
// } else {
//   this.unprocessedPoReportDtoList.forEach(pdto => {
//     pdto.rowCheck = false;
//     this.selectedUnprocessedPoReportDtoList.push(pdto);
//   });
//   this.unprocessedPoReportDtoList = this.selectedUnprocessedPoReportDtoList;
//   this.fileExportService.selectedUnprocessedPoReportData = [];
// }
}
/****************************************************** Row Selection End ***************************************************/


 /****************************************************** Table Sort Start ***************************************************/
 ChangeSortOrder(exportData) {
  this.exportModal = exportData;
}

exportFile(){

}



/****************************************************** Pagination Start ***************************************************/
mlrOnChangePagination(value) {

  this.mlrPaginationConfiguration.itemsPerPage = value;
  this.mlrPaginationcount = value;
}

mlrPageOnChanged(event) {
  this.mlrPaginationConfiguration.currentPage = event;
}
/****************************************************** Pagination End ***************************************************/


 
onchangeEdit(dataValue: Event, index: number, itemValue) {
  console.log('index..'+index+'..'+ dataValue);
  this.isExtLogchanges = true;
  this.extensiveLoggingList[index].changedField = true;

  if (dataValue) {
  this.extensiveLoggingList[index].status = '1';
 
} else {
  this.extensiveLoggingList[index].status = '0';
}
}

 getExtentiveLogging() {
  this.loading = true;
  this.httpclientService.getExtensiveLoggingList().subscribe(
  data => {
    this.extensiveLoggingList = data;
    this.isExtLogchanges = false;
    this.loading = false;
  }
);
}

reset(){
  this.successMessage = '';
  this.getExtentiveLogging();
}



save(){
  this.loading = true;
  this.successMessage = '';
  if (this.isExtLogchanges) {
  console.log('this.appSettingService.globelUserId..'+sessionStorage.getItem('globelUserId'));
  this.httpclientService.updateExtensiveLogging(sessionStorage.getItem('globelUserId'),  this.extensiveLoggingList
  ).subscribe(
  data => {
    this.extensiveLoggingList = data;
    this.loading = false;
    this.successMessage = 'Extensive Logging is Successfully Updated';
    this.isExtLogchanges = false;
  }
);
} else{
  this.loading = false;
  this.successMessage = 'No Changes have been made';
}
}

}
